import React from "react";
import styled from "@emotion/styled";
import { PlanPopupProps } from "components/Travel/interface";
import FullPopup from "components/Common/PC/PopupFull";
import GuaranteeTable from "components/Travel/PC/GuaranteeTable";

const PlanPopup: React.FunctionComponent<PlanPopupProps> = ({
  togglePopup,
  contents,
  name,
  planType
}) => (
  <FullPopup title="보장내용" onOk={togglePopup} isLarge={true}>
    <>
      <Name>{name}님 플랜</Name>
      <GuaranteeTable contents={contents} planType={planType} />
    </>
  </FullPopup>
);

export default PlanPopup;

const Name = styled.p`
  margin-top: -19px;
  margin-bottom: 19px;
  letter-spacing: -0.3;
`;
